import { DataKey, DataRecord, TimeUnitKey } from '../../../types';
import getTimeUnitSorter from './get-time-unit-sorter';

const sortRecordsByTimeUnit = (
    records: DataRecord[],
    timeUnitKey: TimeUnitKey,
    columns: DataKey[]
) => {
    const timeUnitSorter = getTimeUnitSorter(timeUnitKey);
    const timeUnitIdx = columns.indexOf(timeUnitKey);

    return records.sort((a, b) => timeUnitSorter(a[timeUnitIdx], b[timeUnitIdx]));
};

export default sortRecordsByTimeUnit;
